import { Check } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useVendorAuth } from '@/auth/VendorAuthProvider'
import { AuthLayout } from '@/components/AuthLayout'
import { PasswordInput, Spinner } from '@/components/ui'

function ruleMet(ok: boolean, label: string) {
  return (
    <li className={ok ? 'flex items-center gap-1.5 text-success' : 'flex items-center gap-1.5 text-ink-faint'}>
      <Check className="h-3.5 w-3.5" /> {label}
    </li>
  )
}

export function FirstLoginChange() {
  const { changePassword, logout } = useVendorAuth()
  const navigate = useNavigate()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const hasLength = next.length >= 8
  const hasNumber = /\d/.test(next)
  const matches = next.length > 0 && next === confirm
  const canSubmit = hasLength && hasNumber && matches && current.length > 0

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!canSubmit) return
    setError(null)
    setBusy(true)
    try {
      await changePassword(current, next)
      navigate('/', { replace: true })
    } catch (err) {
      setError((err as Error).message || 'No se pudo cambiar la contraseña.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout title="Creá tu contraseña" subtitle="Por seguridad, cambiá la contraseña inicial antes de continuar">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="field-label">Contraseña actual (la que te dieron)</label>
          <PasswordInput required value={current} onChange={(e) => setCurrent(e.target.value)} />
        </div>
        <div>
          <label className="field-label">Nueva contraseña</label>
          <PasswordInput required value={next} onChange={(e) => setNext(e.target.value)} />
        </div>
        <div>
          <label className="field-label">Repetir nueva contraseña</label>
          <PasswordInput required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>

        <ul className="space-y-1 text-xs">
          {ruleMet(hasLength, 'Mínimo 8 caracteres')}
          {ruleMet(hasNumber, 'Al menos 1 número')}
          {ruleMet(matches, 'Las contraseñas coinciden')}
        </ul>

        {error && <div className="rounded-lg bg-danger/5 px-3 py-2 text-sm text-danger">{error}</div>}

        <button className="btn-primary btn-block" disabled={!canSubmit || busy}>
          {busy ? <Spinner className="h-4 w-4" /> : 'Guardar y continuar'}
        </button>
        <button type="button" className="btn-ghost btn-block" onClick={logout}>
          Cancelar y salir
        </button>
      </form>
    </AuthLayout>
  )
}
